import { render, staticRenderFns } from "./aufgaben_table.vue?vue&type=template&id=660151ac&scoped=true"
import script from "./aufgaben_table.vue?vue&type=script&lang=js"
export * from "./aufgaben_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660151ac",
  null
  
)

export default component.exports